import qs from 'qs';

export const getQueryParams = queryString => qs.parse(queryString, { ignoreQueryPrefix: true });

export const getQueryString = queryObject =>
  queryObject ? qs.stringify(queryObject, { addQueryPrefix: true, arrayFormat: 'indicies' }) : '';

export const stripTrailingSlash = str => (str.endsWith('/') ? str.slice(0, -1) : str);
